/* Kovoo laser tag landing — cart drawer, gallery, bundles. No dependencies. */
(() => {
  const KL = window.KL || { routes: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = (KL.routes.root || '/').replace(/\/?$/, '/');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => {
    const fmt = KL.moneyFormat || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };

  /* ---------------- cart drawer ---------------- */
  const SECTION = 'kl-cart';
  const drawer = () => document.getElementById('KlCart');
  let lastFocus = null;

  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });

  const render = (html) => {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('KlCartInner');
    const cur = document.getElementById('KlCartInner');
    if (fresh && cur) {
      cur.replaceWith(fresh);
      setCount(parseInt(fresh.dataset.count || '0', 10));
    }
    syncGift();
    // Safety net: Shipping Protection is one per order, even if an old cart has more.
    const one = $('[data-single-line]');
    if (one && Number(one.dataset.qtyNow) > 1) {
      const line = Number(one.closest('[data-line]').dataset.line);
      setTimeout(() => cart.change(line, 1).catch(() => {}), 0);
    }
  };

  const post = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  };

  const refresh = async () => {
    try {
      const res = await fetch(`${root}?sections=${SECTION}`, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      render(data[SECTION]);
    } catch (e) { /* keep current markup */ }
  };

  const open = () => {
    const d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    void d.offsetWidth; // commit hidden=false before transitioning
    d.classList.add('is-open');
    document.body.classList.add('is-locked');
    setTimeout(() => { const p = $('.kl-cart__panel', d); p && p.focus(); }, 60);
  };
  const close = () => {
    const d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  const cart = {
    async add(items) {
      const data = await post(`${root}cart/add.js`, { items, sections: SECTION });
      render(data.sections && data.sections[SECTION]);
      $$('.kl-cartbtn').forEach((b) => { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
      return data;
    },
    async change(line, quantity) {
      const data = await post(`${root}cart/change.js`, { line, quantity, sections: SECTION });
      render(data.sections && data.sections[SECTION]);
      return data;
    }
  };
  KL.cart = cart;

  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-cart-close]')) {
      e.preventDefault(); close();
      if (t.closest('[data-scroll-buy]')) scrollToBuy();
      return;
    }
    const q = t.closest('[data-qty]');
    if (q && q.closest('#KlCart')) {
      const row = q.closest('[data-line]');
      row && row.classList.add('is-busy');
      try { await cart.change(parseInt(row.dataset.line, 10), Math.max(0, parseInt(q.dataset.qty, 10))); }
      catch (err) { row && row.classList.remove('is-busy'); alert(err.message); }
      return;
    }
    const addV = t.closest('[data-add-variant]');
    if (addV) {
      addV.classList.add('is-loading');
      try { await cart.add([{ id: Number(addV.dataset.addVariant), quantity: 1 }]); }
      catch (err) { addV.classList.remove('is-loading'); alert(err.message); }
      return;
    }
    const rv = t.closest('[data-reward-reveal]');
    if (rv) { revealReward(rv); return; }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      const f = $$('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])', d).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Surprise gift: only announced after Shopify confirms the code applies to this cart.
     Once revealed it stays reserved for a few minutes; when that time runs out the code is
     really removed from the cart, so the countdown is never fake. */
  const giftMinutes = () => Number((drawer() || {}).dataset?.giftMinutes) || 5;
  async function revealReward(btn) {
    const code = btn.dataset.code;
    const err = () => { const el = $('[data-reward-err]'); if (el) el.hidden = false; btn.classList.remove('is-busy'); };
    btn.classList.add('is-busy');
    const inner = () => document.getElementById('KlCartInner');
    const applied = () => inner() && inner().dataset.reward === 'on';
    const attributes = { _gift_until: String(Date.now() + giftMinutes() * 60000) };
    try {
      const data = await post(`${root}cart/update.js`, { discount: code, attributes, sections: SECTION });
      render(data.sections && data.sections[SECTION]);
      if (!applied()) {
        // Fallback: the classic discount URL stores the code on the cart session.
        await fetch(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root + 'cart.js')}`, { credentials: 'same-origin' });
        await refresh();
      }
      if (applied()) giftFx(Number(inner().dataset.giftAmount) || 0); else err();
    } catch (e) { err(); }
  }

  const GIFT_SVG = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4"/><path d="M5 12v8h14v-8M12 8v12M12 8S10.5 4 8 4.5 8.5 8 12 8zm0 0s1.5-4 4-3.5S15.5 8 12 8z"/></svg>';
  function giftFx(amount) {
    const panel = $('.kl-cart__panel'); if (!panel) return;
    const fx = document.createElement('div');
    fx.className = 'kl-giftfx';
    fx.setAttribute('role', 'status');
    fx.innerHTML = `<div class="kl-giftfx__card"><div class="kl-giftfx__burst" aria-hidden="true">${'<i></i>'.repeat(16)}</div><div class="kl-giftfx__box">${GIFT_SVG}</div><p class="kl-giftfx__t">Surprise gift unlocked!</p><p class="kl-giftfx__amt">You save <b>${money(reduce ? amount : 0)}</b></p><p class="kl-giftfx__note">Reserved for ${giftMinutes()} minutes. Check out to keep it.</p></div>`;
    panel.appendChild(fx);
    const b = $('.kl-giftfx__amt b', fx);
    if (!reduce && amount) {
      const t0 = performance.now(), dur = 1100;
      const step = (t) => { const k = Math.min(1, (t - t0 - 450) / dur); if (k > 0) b.textContent = money(Math.round(amount * (1 - Math.pow(1 - k, 3)))); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }
    const done = () => { fx.classList.add('is-out'); setTimeout(() => fx.remove(), 350); };
    fx.addEventListener('click', done);
    setTimeout(done, reduce ? 1800 : 3200);
  }

  let giftTimer = null, giftBar = null, expiring = false;
  function syncGift() {
    const inner = document.getElementById('KlCartInner');
    const until = inner ? Number(inner.dataset.giftUntil) : 0;
    const on = inner && inner.dataset.reward === 'on' && until > 0;
    clearInterval(giftTimer);
    if (!on) { if (giftBar) giftBar.hidden = true; document.body.classList.remove('has-gift'); return; }
    if (!giftBar) {
      giftBar = document.createElement('div');
      giftBar.className = 'kl-giftbar';
      giftBar.innerHTML = `<span class="kl-giftbar__ic">${GIFT_SVG}</span><span class="kl-giftbar__t">Your surprise gift expires in <b data-gb-clock>05:00</b></span><button type="button" class="kl-btn kl-btn--sm" data-cart-open>Checkout</button>`;
      document.body.appendChild(giftBar);
    }
    const pad = (n) => String(n).padStart(2, '0');
    const tick = async () => {
      const left = until - Date.now();
      if (left <= 0) {
        clearInterval(giftTimer); giftBar.hidden = true; document.body.classList.remove('has-gift');
        if (expiring) return; expiring = true;
        try {
          const data = await post(`${root}cart/update.js`, { discount: '', attributes: { _gift_until: '', _gift_expired: '1' }, sections: SECTION });
          render(data.sections && data.sections[SECTION]);
        } catch (e) { /* retry on next sync */ } finally { expiring = false; }
        return;
      }
      const txt = `${pad(Math.floor(left / 6e4))}:${pad(Math.floor(left / 1e3) % 60)}`;
      $('[data-gb-clock]', giftBar).textContent = txt;
      const dc = $('[data-gift-clock]'); if (dc) { dc.textContent = txt; dc.closest('[data-gift-left]').hidden = false; }
      giftBar.hidden = false; document.body.classList.add('has-gift');
    };
    tick(); giftTimer = setInterval(tick, 1000);
  }

  /* back/forward (with or without bfcache) and other tabs: keep drawer and count in sync */
  const isBack = (e) => e.persisted || (performance.getEntriesByType('navigation')[0] || {}).type === 'back_forward';
  window.addEventListener('pageshow', (e) => { if (isBack(e)) refresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });

  function scrollToBuy() {
    const buy = document.getElementById('buy');
    if (buy) buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-scroll-buy]');
    if (a) { e.preventDefault(); scrollToBuy(); }
  });

  /* Mouse drag for the sideways rows (desktop and phone simulators on a computer).
     Real fingers keep the browser's own scrolling, which is the smoothest on phones. */
  $$('[data-track], .kl-clips__track, .kl-moments__track').forEach((t) => {
    let down = false, moved = false, x0 = 0, s0 = 0, dx = 0;
    const step = () => (t.children.length > 1 ? t.children[1].offsetLeft - t.children[0].offsetLeft : t.clientWidth) || 1;
    t.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; x0 = e.clientX; s0 = t.scrollLeft; dx = 0;
    });
    window.addEventListener('pointermove', (e) => {
      if (!down) return;
      dx = e.clientX - x0;
      if (!moved) { if (Math.abs(dx) < 5) return; moved = true; t.classList.add('is-grab'); }
      t.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return;
      down = false;
      if (!moved) return;
      const st = step(), n = t.children.length;
      let i = Math.round(s0 / st);
      if (Math.abs(dx) > st * 0.15) i += dx < 0 ? 1 : -1;
      const c = t.children[Math.max(0, Math.min(n - 1, i))];
      const left = t.matches('[data-track]') ? c.offsetLeft - (t.clientWidth - c.offsetWidth) / 2 : c.offsetLeft;
      t.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(() => t.classList.remove('is-grab'), reduce ? 0 : 450);
    });
    // a drag is not a click (no zoom popup after dragging a photo)
    t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    t.addEventListener('dragstart', (e) => e.preventDefault());
  });

  /* ---------------- product page ---------------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const form = $('[data-form]', pdp);
    const idInput = $('[data-variant-input]', pdp);
    const atc = $('[data-atc]', pdp);
    const atcPrice = $('[data-atc-price]', pdp);
    const err = $('[data-error]', pdp);
    const sticky = $('[data-sticky]', pdp);

    /* shown price = bundle + the add-ons ticked inside the selected card */
    const paint = () => {
      const radio = $('.kl-bundle__radio:checked', pdp); if (!radio) return;
      let price = Number(radio.dataset.price), cmp = Number(radio.dataset.compare) || price;
      $$('.kl-bundle.is-on [data-addon][aria-pressed="true"]', pdp).forEach((a) => {
        const p = Number(a.dataset.price) || 0;
        price += p; cmp += Math.max(p, Number(a.dataset.compare) || 0);
      });
      $('[data-price-now]', pdp).textContent = money(price);
      const was = $('[data-price-was]', pdp), save = $('[data-price-save]', pdp);
      if (cmp > price) { was.textContent = money(cmp); was.hidden = false; save.textContent = `Save ${money(cmp - price)}`; save.hidden = false; }
      else { was.hidden = true; save.hidden = true; }
      atcPrice.textContent = money(price);
      const sp = $('[data-sticky-price]', pdp); if (sp) sp.textContent = money(price);
    };
    const selectBundle = (radio, push = true) => {
      if (!radio || radio.disabled) return;
      radio.checked = true;
      $$('.kl-bundle', pdp).forEach((l) => l.classList.toggle('is-on', l.contains(radio)));
      idInput.value = radio.value;
      const inc = $('[data-includes-text]', pdp); if (inc) inc.textContent = radio.dataset.includes || '';
      const st = $('[data-sticky-title]', pdp); if (st) st.textContent = radio.dataset.title;
      paint();
      if (push) { try { history.replaceState({}, '', `${location.pathname}?variant=${radio.value}${location.hash}`); } catch (e) { /* noop */ } }
    };
    pdp.addEventListener('change', (e) => { if (e.target.matches('.kl-bundle__radio')) selectBundle(e.target); });
    /* optional add-ons inside a bundle card: off until the shopper turns them on */
    pdp.addEventListener('click', (e) => {
      const b = e.target.closest('[data-addon]');
      if (!b) return;
      e.preventDefault();
      const r = $('.kl-bundle__radio', b.closest('.kl-bundle'));
      if (r && !r.checked) selectBundle(r);
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      paint();
    });
    window.addEventListener('pageshow', (e) => { if (isBack(e)) selectBundle($('.kl-bundle__radio:checked', pdp), false); });

    document.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-pick]');
      if (!pick) return;
      const r = $(`.kl-bundle__radio[value="${pick.dataset.pick}"]`, pdp);
      selectBundle(r);
      scrollToBuy();
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      err.hidden = true;
      atc.classList.add('is-loading');
      const items = [{ id: Number(idInput.value), quantity: 1 }];
      const picked = $$('.kl-bundle.is-on [data-addon][aria-pressed="true"]', pdp);
      // One-per-order add-ons (Shipping Protection) are skipped if the cart already has them.
      let inCart = [];
      if (picked.some((a) => a.hasAttribute('data-single'))) {
        try { inCart = (await (await fetch(`${root}cart.js`)).json()).items.map((i) => i.variant_id); } catch (ex) { /* add anyway */ }
      }
      picked.forEach((a) => { const id = Number(a.dataset.addon); if (!(a.hasAttribute('data-single') && inCart.includes(id))) items.push({ id, quantity: 1 }); });
      try { await cart.add(items); open(); }
      catch (ex) { err.textContent = ex.message; err.hidden = false; }
      finally { atc.classList.remove('is-loading'); }
    });

    /* sticky add-to-cart: only after the main button scrolls away */
    if (sticky && 'IntersectionObserver' in window) {
      const btn = $('[data-sticky-btn]', sticky);
      const setOn = (on) => {
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
        document.body.style.setProperty('--sticky-h', on && innerWidth < 990 ? `${sticky.offsetHeight}px` : '0px');
      };
      new IntersectionObserver(([en]) => setOn(!en.isIntersecting && en.boundingClientRect.top < 0)).observe(atc);
      btn.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
    }

    /* gallery: native horizontal scroll-snap; JS only syncs indicators */
    const track = $('[data-track]', pdp);
    if (track) {
      const slides = $$('[data-slide]', track);
      const dots = $$('[data-dot]', pdp);
      const thumbs = $$('[data-thumb]', pdp);
      const count = $('[data-count]', pdp);
      let idx = 0;
      const step = () => (slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth) || 1;
      // Swiping is the browser's own scroll-snap (smoothest on iOS); buttons scroll to the exact snap point.
      const go = (i) => {
        const s = slides[(i + slides.length) % slides.length];
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      };
      const sync = (i) => {
        if (i === idx && count && count.textContent === String(i + 1)) return;
        idx = i;
        dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
        thumbs.forEach((t, j) => {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          if (j === i) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        });
        if (count) count.textContent = i + 1;
        // Safari can leave lazy images blank inside a sideways scroller: load the neighbours now.
        for (let j = i - 1; j <= i + 2; j++) if (slides[j]) $$('img[loading="lazy"]', slides[j]).forEach((im) => { im.loading = 'eager'; });
        slides.forEach((s, j) => $$('video', s).forEach((v) => {
          if (j === i) { v.muted = true; v.play().catch(() => {}); } else v.pause();
        }));
      };
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sync(Math.min(slides.length - 1, Math.round(track.scrollLeft / step()))));
      }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
      dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.go))));
      $$('[data-dir]', pdp).forEach((b) => b.addEventListener('click', () => go(idx + Number(b.dataset.dir))));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
      let lastW = innerWidth;
      window.addEventListener('resize', () => { if (innerWidth === lastW) return; lastW = innerWidth; track.scrollLeft = idx * step(); }, { passive: true });

      /* lightbox zoom */
      const lb = $('[data-lightbox]', pdp);
      if (lb && lb.showModal) {
        pdp.addEventListener('click', (e) => {
          const z = e.target.closest('[data-zoom]');
          if (!z) return;
          lb.showModal();
          document.body.classList.add('is-locked');
          const target = $(`[data-lb-index="${z.dataset.zoom}"]`, lb);
          const lt = $('[data-lb-track]', lb);
          if (target && lt) lt.scrollLeft = target.offsetLeft;
        });
        $('[data-lb-close]', lb).addEventListener('click', () => lb.close());
        lb.addEventListener('close', () => { document.body.classList.remove('is-locked'); $$('.kl-lb__img.is-zoom', lb).forEach((i) => i.classList.remove('is-zoom')); });
        lb.addEventListener('click', (e) => {
          const img = e.target.closest('.kl-lb__img');
          if (img) img.classList.toggle('is-zoom');
        });
      }
    }
  }

  /* autoplay short clips only while visible */
  const clips = $$('.kl-clip video');
  if (clips.length && 'IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((ens) => ens.forEach((en) => {
      const v = en.target; v.muted = true;
      if (en.isIntersecting) v.play().catch(() => {}); else v.pause();
    }), { threshold: 0.5 });
    clips.forEach((v) => io.observe(v));
  }
  // tap a clip to pause or play it (a drag never counts as a tap)
  clips.forEach((v) => v.addEventListener('click', () => { if (v.paused) v.play().catch(() => {}); else v.pause(); }));

  /* launch countdown: counts to one fixed date for every visitor, hides at zero, never restarts */
  const timer = $('[data-offer-end]');
  if (timer) {
    const end = Date.parse(timer.dataset.offerEnd);
    const h = $('[data-h]', timer), m = $('[data-m]', timer), s = $('[data-s]', timer);
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      if (!(left > 0)) { timer.hidden = true; clearInterval(t); return; }
      h.textContent = pad(Math.floor(left / 36e5)); m.textContent = pad(Math.floor(left / 6e4) % 60); s.textContent = pad(Math.floor(left / 1e3) % 60);
      timer.hidden = false;
    };
    const t = setInterval(tick, 1000); tick();
  }

  /* delivery estimate: today + min/max days, shown in the shopper's own date format */
  const fmtDay = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
  $$('[data-eta]').forEach((el) => { el.textContent = `${fmtDay(+el.dataset.min)} – ${fmtDay(+el.dataset.max)}`; });
  $$('[data-ship]').forEach((el) => {
    const t = $('[data-ship-today]', el); if (t) t.textContent = `Today, ${fmtDay(0)}`;
    const r = $('[data-ship-range]', el); if (r) r.textContent = `${fmtDay(+el.dataset.min)} – ${fmtDay(+el.dataset.max)}`;
  });
  syncGift();

  /* reveal on scroll */
  const els = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  } else els.forEach((e) => e.classList.add('is-in'));

  /* theme editor */
  document.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector('#KlCart')) open(); });
  document.addEventListener('shopify:section:deselect', (e) => { if (e.target.querySelector('#KlCart')) close(); });
})();
